import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';
import axiosInstance from "@/api/axiosConfig.js";

const MODULE_NAME = 'AuthAPI';

export const authAPI = {

  logout: async (showNotification = false) => {
    try {
      const response = await api.get('/auth/logout');
      return handleSuccessResponse(response, MODULE_NAME, 'Выход из профиля', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'Выход из профиля');
    }
  },

  login: async (email, password) => {

    const formData = new FormData();
    formData.append('username', email);
    formData.append('password', password);

    const response = await axiosInstance.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const token = response.data.token
    localStorage.setItem('token', token.access_token);
    return response.data;
  },

  me: async () => {
    const response = await axiosInstance.get('/auth/me');
    if(response.data) {
      const localStorageMethods = localStorage.getItem('methods')
      const jsonStringifyMethods =JSON.stringify(response.data.methods)
      localStorage.setItem('methods', jsonStringifyMethods);
      if(localStorageMethods === null || localStorageMethods !== jsonStringifyMethods) location.reload();
    }
    return response.data ? response.data : response;
  },
};